export default {
  STEP: `Step {{step}} of {{steps}}`,
  NEXT_STEP: `Next Step`,
  PREVIOUS_STEP: `Previous Step`,
  DEVICECHECK_WELCOME_HEADING: `Let’s get started`,
  DEVICECHECK_WELCOME_INSTRUCTIONS: `Click "allow" when your browser asks for access to your camera and microphone.`,
  DEVICECHECK_WELCOME_START_BTN: `Start device check`,
  DEVICECHECK_WELCOME_BROWSER_CHECK: `Browser\ncheck`,
  DEVICECHECK_WELCOME_AV_CHECK: `Audio & video\ncheck`,
  DEVICECHECK_WELCOME_ALL_SETUP: `You're\nset up!`,
  DEVICECHECK_WELCOME_FIRST_STEP_COMPLETED: `First step completed`,

  DEVICECHECK_COMPLETE_HEADING: `Good job!\nYou’re all set.`,
  DEVICECHECK_COMPLETE_CONTENT: `<0>We look forward to seeing you at your appointment time.</0><1>You may now close this window.</1>`,
  DEVICECHECK_COMPLETE_FAQ_BTN: `Still got questions? Visit our FAQ`,

  SPEAKER_TEST_HEADER: `Speaker Test`,
  PLEASE_SELECT_DEVICE: `Please select your output device.`,
  DO_YOU_HEAR_SOUND: `Do you hear the sound?`,
  PRESS_PLAY_SOUND: `Select the "Play Sound" button.`,
  PLAY_BUTTON: `Play Sound`,
  CHANGE_SPEAKERS: `If you need to change your speakers, please use your device’s preferences.`,
  MY_DEVICE_SOUND_IS_GOOD: `My device has it’s volume up, and I am aware of my bluetooth settings.`,
  YES_I_HEAR_IT: `Yes, I hear it`,
  TROUBLESHOOT_SPEAKERS: `Troubleshoot your speakers`,

  CAMERA_TEST_HEADER: `Camera Test`,
  NO_CAMERA: `We cannot detect a camera, but you can still attend your appointment with audio\u00A0only.`, // use \u00A0 to prevent single orphan words on new lines
  OK: `OK`,
  HELP_WITH_CAMERA_DETECTION: `Get help with camera detection`,
  DO_YOU_SEE_YOURSELF_IN_YOUR_CAMERA: `Do you see yourself?`,
  I_UNDERSTAND_CAMERA_ABILITIES: `I know that I can turn off my camera during my appointment if I don’t want to be seen.`,
  YES_I_SEE_MYSELF: `Yes, I see myself`,
  TROUBLESHOOT_CAMERA: `Troubleshoot your camera`,
  YOUR_CAMERA_VIEW: `Video from your camera`,
  CAMERA_LOADING: `Camera loading ...`,

  MICROPHONE_TEST_HEADER: `Microphone Test`,
  SAY_SOMETHING: `Say something.`,
  YOU_SEE_THE_BAR_MOVING: `Do you see the audio bar moving?`,
  MY_ENVIRONMENT_IS_PERFECT_FOR_CALLS: `I have minimal background noise and can have my call undistracted.`,
  TROUBLESHOOT_MICROPHONE: `Troubleshoot your microphone`,
  MICROPHONE_SOUND_LEVEL: `Microphone sound level`,
  YES_I_SEE_IT: `Yes, I see it`,
  NO_I_NEED_HELP: `No, I need help`,

  ERROR_PAGE_TITLE: `Oops, something went wrong on our end`,
  ERROR_PAGE_HELP_1: `Please try to refresh your browser or contact your practice.`,
  ERROR_PAGE_HELP_2: `Thank you for your patience as we resolve technical issues.`,
  INVALID_APPT_PAGE: `
    <0>Uh oh, this link is not active</0>
    <1>This link is only active on the day of your appointment.<br role="presentation"><br role="presentation">
    In the meantime, take a moment to ensure everything is working for your call by running our quick device check.</1>`,
  INVALID_APPT_PAGE_START_DEVICE_CHECK: `Start device check`,
  INVALID_APPT_PAGE_MESSAGE_IN_ERROR: `If you think you have received this message in error, please contact your practice.`,

  INVALID_DEEPLINK_TITLE: `This link is not available`,
  INVALID_DEEPLINK_CONTENT: `Please access your practice portal or appointment reminders for the visit link.`,
};
